import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { Encrypt } from '../../utils/encrypt/encrypt';
import { UserInformation } from '../../models/userInformation.model';

@Component({
  selector: 'app-products-checkout',
  templateUrl: './products-checkout.component.html',
})
export class ProductsCheckoutComponent implements OnInit, OnDestroy {
  private isBrowser: boolean;
  userInformation: UserInformation;
  cellPhone: string;
  description: string = '';

  constructor(
    @Inject(DOCUMENT) private document: any,
    private cookieCiencuadras: CookieCiencuadras,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.initializeUserData();

    if (this.isBrowser) {
      this.loadCarritoScript();
    }
  }

  /**
   * Inicializa los datos del usuario y la descripción
   */
  private initializeUserData(): void {
    let cripto = new Encrypt();
    this.userInformation = cripto.decryptData(
      this.cookieCiencuadras.getCookie('userInfo'),
    );

    this.cellPhone = this.userInformation.cellPhone
      ? this.userInformation.cellPhone
      : '3171234567';

    if (localStorage.getItem('__app_storage__') !== null) {
      const objItems = JSON.parse(localStorage.getItem('__app_storage__')!);
      if (objItems.carPlanCheckout.length > 0) {
        this.description += objItems.carPlanCheckout[0].name;
      }
      if (objItems.carCheckout.length > 0) {
        objItems.carCheckout.forEach((products) => {
          this.description += '-' + products.name;
        });
      }
    }
  }

  /**
   * Configura el carrito una vez que el script ha sido cargado
   */
  private setupCarSummary(): void {
    const userID = this.userInformation.identification
      ? this.userInformation.identification
      : this.userInformation.id?.toString();

    let retentions = {
      calculaRetenciones: true,
      aplicaReteIva: false,
      aplicaReteIca: false,
      tarifaReteFuente: 0,
      ciudad: {},
    };

    if (this.isBrowser) {
      const legalFormData = sessionStorage.getItem('legalForm');
      if (legalFormData) {
        const legalForm = JSON.parse(legalFormData);
        if (legalForm) {
          this.userInformation.name = legalForm?.name;
          this.userInformation.lastname = legalForm?.surname;
          this.userInformation.email = legalForm?.billingEmail;
          this.cellPhone = legalForm?.mobile.toString();
          if (legalForm.legalBillingInfo) {
            retentions.aplicaReteIca =
              legalForm?.legalBillingInfo?.icaWithholding;
            retentions.aplicaReteIva =
              legalForm?.legalBillingInfo?.ivaWithholding;
            retentions.tarifaReteFuente =
              legalForm?.legalBillingInfo?.incomeWithholding;
          }
          if (legalForm.cityId) {
            retentions.ciudad = {
              codigo: legalForm.cityId?.toString(),
              name: legalForm.city?.city_value,
            };
          }
        }
      }
    }

    console.log('>> retentions', retentions);

    let carSummary = this.document.querySelector('car-summary');
    if (!carSummary) {
      console.error('car-summary element not found');
      return;
    }

    carSummary.retentions = retentions;
    carSummary.tokenExternal = environment.ShoppingCart.tokenExternal;
    carSummary.showBonus = 0;
    carSummary.setUp.editCar = false;
    carSummary.is_unregisteredu_ser = true;
    carSummary.gatewayCode = {
      api: environment.ShoppingCart.api,
      secretKey: environment.ShoppingCart.secretKeyGateway,
      ivKey: environment.ShoppingCart.ivGateway,
    };
    carSummary.userId = userID;
    carSummary.customization = {
      mainActionText: 'Pagar',
      secondaryActionText: 'SEGUIR COMPRANDO',
      title: 'Portal ciencuadras',
      keepBuying: '/productos/',
    };
    carSummary.dataPay = {
      name: this.userInformation.name,
      lastName: this.userInformation.lastname,
      email: this.userInformation.email,
      phone: this.cellPhone,
      typeUser: this.userInformation?.isNit === 1 ? 'J' : 'N',
      idType: this.userInformation?.isNit === 1 ? 'NIT' : 'CC',
      id: userID,
      description: this.description,
      vat: 0,
      urlReturn: environment.environmenturl,
      routeConfirmation: `productos?id=`,
      keepBuying: '/',
      subClient: environment.ShoppingCart.subclient,
    };
  }

  setProductsShoppingCart(product: any) {
    console.log(product.detail);
  }

  /**
   * Carga dinámicamente el script del carrito
   */
  private loadCarritoScript(): void {
    const scriptId = 'carrito-script';
    const scriptUrl = environment.shoppingCartWidgetUrl;

    if (this.document.getElementById(scriptId)) {
      this.setupCarSummary();
      return;
    }

    const script = this.document.createElement('script');
    script.id = scriptId;
    script.src = scriptUrl;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      this.setupCarSummary();
    };

    script.onerror = (error) => {
      console.error('Error al cargar el script del carrito:', error);
    };

    this.document.head.appendChild(script);
  }

  ngOnDestroy(): void {
    const script = this.document.getElementById('carrito-script');
    if (script) {
      script.remove();
    }
  }
}
